import { Box, Tab, Tabs, Typography } from "@mui/material";
import { MapContext } from "pages/maps/map";
import React, { useState } from "react";
import ComplianceBaseTabs from "./BaseTabs";
import CreditReportDetails from "./CreditReport";
import ComplianceEvaluation from "./Evaluation";
import ComplianceScoring from "./Scoring";
import ComplianceScreening from "./Screening";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3, py: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const Compliance = () => {
  const id = React.useContext(MapContext);

  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="map-tabs"
          variant="fullWidth"
        >
          <Tab label="Credit Report" {...a11yProps(0)} />
          <Tab label="Screening & ID Verification" {...a11yProps(1)} />
          <Tab label="Evaluation" {...a11yProps(2)} />
          <Tab label="Checklist, Scoring & Approval" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ComplianceBaseTabs Section={CreditReportDetails} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ComplianceBaseTabs Section={ComplianceScreening} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ComplianceBaseTabs Section={ComplianceEvaluation} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ComplianceBaseTabs Section={ComplianceScoring} />
      </CustomTabPanel>
    </Box>
  );
};

export default Compliance;
